export const STOCK_DRAWER: {
    title: string;
    repositoryUrl: string;
    liveUrl: string | null;
    video: string;
    poster: string;
    captions: string;
} = {
    title: "Stock Drawer",
    liveUrl: "https://stock-drawer.vercel.app/",
    repositoryUrl: "https://github.com/JarrodSavard/stock-drawer",
    video: `${process.env.PUBLIC_URL}/videos/stock-drawer-showcase-1080p.mp4`,
    poster: `${process.env.PUBLIC_URL}/videos/stock-drawer-poster.jpg`,
    captions: `${process.env.PUBLIC_URL}/videos/stock-drawer-en.vtt`,
};
